/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A categorization of institutions, derived from CAPS requirements
 * @export
 */
export const OrganizationType = {
    ACADEMIC_RESEARCH_INSTITUTION: 'ACADEMIC_RESEARCH_INSTITUTION',
    INDUSTRY: 'INDUSTRY',
    EDUCATIONAL_INSTITUTION: 'EDUCATIONAL_INSTITUTION',
    HEALTH_CENTER_NON_PROFIT: 'HEALTH_CENTER_NON_PROFIT',
    OTHER: 'OTHER'
} as const;
export type OrganizationType = typeof OrganizationType[keyof typeof OrganizationType];


export function OrganizationTypeFromJSON(json: any): OrganizationType {
    return OrganizationTypeFromJSONTyped(json, false);
}

export function OrganizationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationType {
    return json as OrganizationType;
}

export function OrganizationTypeToJSON(value?: OrganizationType | null): any {
    return value as any;
}

